export enum Callback {
	onBlur = 'onBlur',
	onChange = 'onChange',
	onChangeHeaderCells = 'onChangeHeaderCells',
	onChangePage = 'onChangePage',
	onClick = 'onClick',
	onClose = 'onClose',
	onDblClick = 'onDblClick',
	onFocus = 'onFocus',
	onInput = 'onInput',
	onKeyDown = 'onKeyDown',
	onKeyPress = 'onKeyPress',
	onKeyUp = 'onKeyUp',
	onMouseDown = 'onMouseDown',
	onMouseMove = 'onMouseMove',
	onMouseOut = 'onMouseOut',
	onMouseOver = 'onMouseOver',
	onMouseUp = 'onMouseUp',
	onReset = 'onReset',
	onSelect = 'onSelect',
	onSelectionChange = 'onSelectionChange',
	onChangePageSize = 'onChangePageSize',
	onSort = 'onSort',
	onSubmit = 'onSubmit',
	onToggle = 'onToggle',
}
